/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IamUserRole,
    IamUserRoleFromJSON,
    IamUserRoleFromJSONTyped,
    IamUserRoleToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetIamUserRoleResponse
 */
export interface GetIamUserRoleResponse {
    /**
     * 
     * @type {IamUserRole}
     * @memberof GetIamUserRoleResponse
     */
    iamUserRole?: IamUserRole;
}

export function GetIamUserRoleResponseFromJSON(json: any): GetIamUserRoleResponse {
    return GetIamUserRoleResponseFromJSONTyped(json, false);
}

export function GetIamUserRoleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIamUserRoleResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamUserRole': !exists(json, 'iam_user_role') ? undefined : IamUserRoleFromJSON(json['iam_user_role']),
    };
}

export function GetIamUserRoleResponseToJSON(value?: GetIamUserRoleResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_user_role': IamUserRoleToJSON(value.iamUserRole),
    };
}


